import { render, staticRenderFns } from "./MainSection.vue?vue&type=template&id=083bc357&"
import script from "./MainSection.vue?vue&type=script&lang=js&"
export * from "./MainSection.vue?vue&type=script&lang=js&"
import style0 from "./MainSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MainSection.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
  VLayout,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
  VSpacer,
  VToolbar,
  VToolbarItems,
})
